import { combineReducers } from 'redux';
import { login } from './loginReducer';
import { emailToken } from './emailTokenReducer';

const authReducers = combineReducers({
  login,
  emailToken,
});

export default authReducers;
